import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./WaterFall.module.css";
import CipherTextPuzzle from "../games/CipherText";
import GameWrapper from "../GameWrapper";
const WaterFall = () => {
  const navigate = useNavigate();

  const handleButtonClick = (path) => {
    navigate(path);
  };

  return (
    <GameWrapper backgroundImage="Waterfall.webp">
      <button
        onClick={() => handleButtonClick("/home")}
        className={`${styles.homeButton} ${styles.button}`}
      >
        Home
      </button>

      <button
        onClick={() => handleButtonClick("/map")}
        className={`${styles.mapButton} ${styles.button}`}
      >
        Map
      </button>

      <CipherTextPuzzle />
    </GameWrapper>
  );
};

export default WaterFall;
